/* eslint-disable react/no-array-index-key */
import styled from 'styled-components';
import DefaultMenuItem from 'components/generic/menu/components/DefaultMenuItem';
import useSmartviewManager from 'components/generic/smartview/shared/hooks/useSmartviewManager';
import { Typography } from 'components/generic/typography';
import Flex from 'components/Layout/components/Flex';
import { findNSelectedOptions } from '../shared/helpers';
import type { RootDefaultMenuItemType } from '../shared/types';
import Icon from 'components/Icon';

const PreviewText = styled(Typography.Body)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 50%;
`;

export default function RootDefaultFilterMenuItem({
    model
}: {
    model: RootDefaultMenuItemType;
}) {
    const {
        displayName,
        options,
        attribute: { id }
    } = model;
    const filterMenuId = id.toString();
    const { toggle } = useSmartviewManager(filterMenuId, 'right');
    const selectedOptions = findNSelectedOptions(options, 8).map((option) => option.displayName);

    const selectedOptionsPreviewText = !!selectedOptions.length && (
        <PreviewText forwardedAs="span" size="S" strong>
            {selectedOptions.join(', ')}
        </PreviewText>
    );

    return (
        <DefaultMenuItem.Button
            afterSlot={<Icon type="ChevronRight" size={16} />}
            buttonProps={{ onClick: () => toggle() }}
        >
            <Flex.Row justifyContent="space-between">
                <span>{displayName}</span>
                {selectedOptionsPreviewText}
            </Flex.Row>
        </DefaultMenuItem.Button>
    );
}
